// src/pages/agents/AddContribuable.jsx
import React, { useState, useEffect } from "react";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import { Link, useNavigate } from "react-router-dom";
import mairieLogo from "../../assets/img/nrf.png";
import mairieLogo1 from "../../assets/img/image.jpeg";
import Select from 'react-select';
import { 
  Card, 
  Row, 
  Col, 
  Form, 
  Button, 
  Spinner, 
  Alert,
  ProgressBar,
  Modal,
  Badge,
  Table
} from "react-bootstrap";
import axios from "axios";
import {
  CheckCircle,
  Save,
  Building,
  Phone,
  GeoAlt,
  Person,
  Briefcase,
  Check,
  X,
  ExclamationCircle,
  FileText,
  Key,
  Printer,
  PlusCircle,
  Eye,
  Search,
  Map,
  CreditCard,
  Receipt,
  InfoCircle,
  Shop,
  Lock,
  People,
  PersonBadge
} from "react-bootstrap-icons";
import { API_BASE_URL } from "../../constants/api_constants";

const TAXPAYERS_ENDPOINT = `${API_BASE_URL}/taxpayers`;
const FORMES_ENDPOINT = `${API_BASE_URL}/formes`;
const USAGER_CATEGORIES_ENDPOINT = `${API_BASE_URL}/usager-categories`;
const LOCALITES_ENDPOINT = `${API_BASE_URL}/localites`;
const MARCHES_ENDPOINT = `${API_BASE_URL}/marches`;

export default function AddContribuable() {
  const navigate = useNavigate();
  
  // ✅ Récupérer les infos de l'utilisateur connecté
  const userData = JSON.parse(sessionStorage.getItem('userData') || '{}');
  const userRoleId = userData?.role_id || null;
  const userMarcheId = userData?.id_marche || null;
  const hasMarket = !!userMarcheId;

  // ✅ LOGS DE DÉBOGAGE
  console.log("=== DÉBOGAGE ADD CONTRIBUABLE ===");
  console.log("userData:", userData);
  console.log("userRoleId:", userRoleId);
  console.log("userMarcheId:", userMarcheId);
  console.log("hasMarket:", hasMarket);

  // ✅ Déterminer si l'utilisateur est Admin Entité (1002)
  const isAdminEntite = userRoleId === 1002;

  // ✅ Déterminer si l'utilisateur est Admin Principal (1003)
  const isAdminPrincipal = userRoleId === 1003;
  const isAdminMarche = userRoleId === 1005;

  // ✅ Déterminer si l'utilisateur est un Collecteur (1013)
  const isCollecteur = userRoleId === 1013;

  // ✅ Déterminer si l'utilisateur est un Agent de Marché (1012)
  const isAgentMarche = userRoleId === 1012;

  // 🔥 MODIFICATION 1 : TOUT LE MONDE peut voir les radios Formel/Informel
  const canSeeRadios = true;

  // ✅ Déterminer si l'utilisateur peut enregistrer des contribuables
  const canRegister = true;

const canSeeMarcheSelect = true;

  // ✅ LOG pour vérifier
  console.log("canSeeRadios:", canSeeRadios);
  console.log("canRegister:", canRegister);
  console.log("canSeeMarcheSelect:", canSeeMarcheSelect);

  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [parentCategories, setParentCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [loadingParentCategories, setLoadingParentCategories] = useState(false);
  const [formesJuridiques, setFormesJuridiques] = useState([]);
  const [loadingFormes, setLoadingFormes] = useState(false);
  const [alertMessage, setAlertMessage] = useState({ show: false, message: '', type: 'info' });
  const [formProgress, setFormProgress] = useState(0);
  
  const [quartiers, setQuartiers] = useState([]);
  const [loadingQuartiers, setLoadingQuartiers] = useState(false);
  const [selectedQuartier, setSelectedQuartier] = useState(null);
  const [allLocalitesData, setAllLocalitesData] = useState([]);
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);
  const [selectedActivityTaxes, setSelectedActivityTaxes] = useState([]);
  const [loadingActivityTaxes, setLoadingActivityTaxes] = useState(false);
  const [showTaxesModal, setShowTaxesModal] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);

  // ✅ État pour le type de contribuable (Formel / Informel)
  const [contribuableType, setContribuableType] = useState('formel');

  // ✅ États pour les marchés
  const [marches, setMarches] = useState([]);
  const [loadingMarches, setLoadingMarches] = useState(false);
  const [selectedMarche, setSelectedMarche] = useState(null);

  const typeLabels = {
    1000: "Commune",
    1001: "Ville",
    1002: "Quartier",
    1003: "Arrondissement",
    1004: "Département",
    1005: "Province"
  };

  const [formData, setFormData] = useState({
    denomination: "",
    nom: "",
    prenom: "",
    forme_juridique: "",
    activite_contribuable: "",
    telephone: "",
    email: "",
    adresse: "",
    quartier_id: "",
    code_postal: "",
    id_nat: "",
    rccm: "",
    nif: "",
    id_marche: "" // 🔥 MODIFICATION : plus de pré-remplissage forcé
  });

  const categoryOptions = categories.map(cat => ({
    value: cat.id_export,
    label: `${cat.name} - ${cat.cat_name}`,
    original: cat
  }));

  const getTypeName = (typeCode) => {
    return typeLabels[typeCode] || "Localité";
  };

  const getQuartierHierarchy = (quartier, allData) => {
    const hierarchy = [];
    let current = quartier;
    
    while (current && current.parent_id) {
      const parent = allData.find(l => l.localite_id === current.parent_id);
      if (parent) {
        hierarchy.unshift({
          nom: parent.nom,
          type: getTypeName(parent.type_code),
          id: parent.localite_id
        });
        current = parent;
      } else {
        break;
      }
    }
    return hierarchy;
  };

  const quartierOptions = quartiers.map(q => {
    const parent = allLocalitesData.find(a => a.localite_id === q.parent_id);
    let label = q.nom;
    if (parent) {
      label += ` - ${parent.nom} (${getTypeName(parent.type_code)})`;
    } else {
      label += ` (Quartier sans parent)`;
    }
    const hierarchy = getQuartierHierarchy(q, allLocalitesData);
    return { 
      value: q.localite_id, 
      label: label,
      original: q,
      parent: parent,
      hierarchy: hierarchy
    };
  });

  // ✅ Options pour les marchés - TOUS les marchés disponibles
  const marcheOptions = canSeeMarcheSelect ? marches.map(m => ({
    value: m.id_marche || m.id,
    label: `${m.id_marche || m.code_marche} - ${m.nom_marche}`,
    original: m
  })) : [];

  const handleCategoryChange = (selectedOption) => {
    setFormData(prev => ({ 
      ...prev, 
      activite_contribuable: selectedOption ? selectedOption.value : '' 
    }));
  };

  const getLocaliteHierarchy = (localiteId, allData) => {
    const hierarchy = [];
    let current = allData.find(l => l.localite_id === localiteId);
    while (current && current.parent_id) {
      const parent = allData.find(l => l.localite_id === current.parent_id);
      if (parent) {
        hierarchy.unshift({
          nom: parent.nom,
          type: getTypeName(parent.type_code),
          id: parent.localite_id
        });
        current = parent;
      } else {
        break;
      }
    }
    return hierarchy;
  };

  const extractLocationInfo = (localiteId, allData) => {
    if (!localiteId || allData.length === 0) return null;
    const foundLocalite = allData.find(l => l.localite_id === localiteId);
    if (!foundLocalite) return null;
    const chain = getLocaliteHierarchy(localiteId, allData);
    chain.push({ nom: foundLocalite.nom, type: getTypeName(foundLocalite.type_code), id: foundLocalite.localite_id });
    let province = null, departement = null, ville = null, commune = null, arrondissement = null, quartier = null;
    chain.forEach(loc => {
      switch (loc.type) {
        case 'Province': if (!province) province = loc.nom; break;
        case 'Département': if (!departement) departement = loc.nom; break;
        case 'Ville': if (!ville) ville = loc.nom; break;
        case 'Commune': if (!commune) commune = loc.nom; break;
        case 'Arrondissement': if (!arrondissement) arrondissement = loc.nom; break;
        case 'Quartier': if (!quartier) quartier = loc.nom; break;
        default: break;
      }
    });
    return { province, departement, ville, commune, arrondissement, quartier, chaineComplete: chain };
  };

  const handleQuartierChange = (selectedOption) => {
    const quartierId = selectedOption ? selectedOption.value : '';
    setSelectedQuartier(selectedOption);
    if (quartierId && allLocalitesData.length > 0) {
      const locationInfo = extractLocationInfo(quartierId, allLocalitesData);
      console.log("Localisation extraite:", locationInfo);
    }
    setFormData(prev => ({ 
      ...prev, 
      quartier_id: quartierId 
    }));
  };

  const handleMarcheChange = (selectedOption) => {
    setSelectedMarche(selectedOption);
    setFormData(prev => ({
      ...prev,
      id_marche: selectedOption ? selectedOption.value : ''
    }));
  };

  // ✅ Gestionnaire pour le changement de type de contribuable
  const handleContribuableTypeChange = (type) => {
    console.log("Changement de type:", type);
    setContribuableType(type);
    if (type === 'informel') {
      const fullName = `${formData.nom || ''} ${formData.prenom || ''}`.trim();
      setFormData(prev => ({
        ...prev,
        denomination: fullName
      }));
    }
  };

  // ✅ Effet pour mettre à jour la dénomination en mode informel
  useEffect(() => {
    if (contribuableType === 'informel' && (formData.nom || formData.prenom)) {
      const fullName = `${formData.nom || ''} ${formData.prenom || ''}`.trim();
      if (fullName) {
        setFormData(prev => ({
          ...prev,
          denomination: fullName
        }));
      }
    }
  }, [contribuableType, formData.nom, formData.prenom]);

  const generateFicheRecensement = async (contribuableData, activiteInfoData, activityTaxes = [], localiteInfo = null, taxationNumber = null) => {
    console.log("=== GÉNÉRATION DE LA NOTE DE TAXATION ===");
    console.log("Taxes reçues:", activityTaxes?.length || 0);
    
    if (isPrinting) return;
    setIsPrinting(true);
    
    let documentInfo = { id_interne: null, date_create: null };
    
    try {
      const documentResponse = await axios.get(`${API_BASE_URL}/document_interne`, { headers: getHeaders() });
      if (documentResponse.data && documentResponse.data.id_interne) {
        documentInfo.id_interne = documentResponse.data.id_interne;
        documentInfo.date_create = documentResponse.data.date_create;
        console.log("✅ ID_DOC récupéré:", documentInfo.id_interne);
      } else {
        documentInfo.id_interne = `NT-${Date.now()}`;
      }
    } catch (error) {
      console.error("❌ Erreur lors de l'appel API /document_interne:", error);
      documentInfo.id_interne = `NT-${Date.now()}`;
    }
    
    const internalDocNumber = documentInfo.id_interne;
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentDay = String(currentDate.getDate()).padStart(2, '0');
    const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
    
    let villeNom = localiteInfo?.ville || "KINSHASA";
    let communeNom = localiteInfo?.commune || "Lemba";
    let quartierNom = localiteInfo?.quartier || "";
    
    const adresseBase = contribuableData?.adresse || "";
    const adresseParts = adresseBase.split(',');
    let numeroAdresse = "";
    let avenueNom = "";
    
    if (adresseParts.length >= 2) {
      numeroAdresse = adresseParts[0].trim().replace('N°', '').trim();
      avenueNom = adresseParts[1].trim();
    } else {
      numeroAdresse = adresseBase.replace('N°', '').trim() || "1132";
      avenueNom = "Itimbiri";
    }
    
    const getDenomination = () => {
      return contribuableData?.nom_contribuable || contribuableData?.nom_entite || "ETS MUANA MBOKA";
    };
    
    const getTaxAmount = (tax) => {
      if (!tax) return 0;
      if (tax.default_amount && parseFloat(tax.default_amount) > 0) return parseFloat(tax.default_amount);
      if (tax.montant && parseFloat(tax.montant) > 0) return parseFloat(tax.montant);
      if (tax.montant_personnalise && parseFloat(tax.montant_personnalise) > 0) return parseFloat(tax.montant_personnalise);
      if (tax.amount && parseFloat(tax.amount) > 0) return parseFloat(tax.amount);
      if (tax.montant_initial && parseFloat(tax.montant_initial) > 0) return parseFloat(tax.montant_initial);
      if (tax.montant_attendu && parseFloat(tax.montant_attendu) > 0) return parseFloat(tax.montant_attendu);
      return 0;
    };
    
    const getTaxName = (tax) => {
      if (!tax) return "Taxe";
      if (tax.taxe_name) return tax.taxe_name;
      if (tax.type) return tax.type;
      if (tax.titre) return tax.titre;
      if (tax.intitule) return tax.intitule;
      if (tax.name) return tax.name;
      if (tax.libelle) return tax.libelle;
      if (tax.nom_taxe) return tax.nom_taxe;
      if (tax.taxe?.titre) return tax.taxe.titre;
      if (tax.tax?.name) return tax.tax.name;
      return "Taxe";
    };
    
    let normalizedTaxes = [];
    if (activityTaxes && Array.isArray(activityTaxes)) {
      normalizedTaxes = activityTaxes;
    } else if (activityTaxes?.data && Array.isArray(activityTaxes.data)) {
      normalizedTaxes = activityTaxes.data;
    } else if (activityTaxes?.taxes && Array.isArray(activityTaxes.taxes)) {
      normalizedTaxes = activityTaxes.taxes;
    }
    
    const taxesList = [];
    let montantTotal = 0;
    
    for (const tax of normalizedTaxes) {
      const montant = getTaxAmount(tax);
      const libelle = getTaxName(tax);
      if (montant > 0) {
        montantTotal += montant;
        taxesList.push({
          libelle: libelle,
          montant: montant,
          montantFormatted: montant.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        });
      }
    }
    
    const hasTaxesDue = taxesList.length > 0 && montantTotal > 0;
    
    const generateTaxRows = () => {
      let html = '';
      let lineNumber = 1;
      if (taxesList.length === 0) {
        html += `<tr style="border: 1px solid #000;">`;
        html += `<td colspan="3" style="padding: 8px; border: 1px solid #000; text-align: center;">Aucune taxe due pour le moment<\/td>`;
        html += `<\/tr>`;
      } else {
        for (const tax of taxesList) {
          html += `<tr style="border: 1px solid #000;">`;
          html += `<td style="padding: 8px; border: 1px solid #000; text-align: center;">${String(lineNumber).padStart(2, '0')}<\/td>`;
          html += `<td style="padding: 8px; border: 1px solid #000;">${tax.libelle}<\/td>`;
          html += `<td style="padding: 8px; border: 1px solid #000; text-align: right;">${tax.montantFormatted}<\/td>`;
          html += `<\/tr>`;
          lineNumber++;
        }
      }
      return html;
    };
    
    const getTaxationNumberValue = () => {
      if (taxationNumber) return taxationNumber;
      if (internalDocNumber) {
        return `${internalDocNumber} / 443 / LB / ECON / ${currentYear}`;
      }
      const contribuableId = contribuableData?.contribuable_id || ' ';
      return `${contribuableId} / 443 / LB / ECON / ${currentYear}`;
    };
    
    const htmlContent = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Note de taxation TPA</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    html, body { 
      height: 100%;
      margin: 0;
      padding: 0;
    }
    body { 
      font-family: 'Arial', 'Helvetica', sans-serif;
      background: white;
      font-size: 14px;
      display: flex;
      flex-direction: column;
      min-height: 100vh;
    }
    @media print {
      @page { size: A4; margin: 1.5cm; }
      body { padding: 0; margin: 0; }
    }
    .document { 
      max-width: 210mm; 
      margin: 0 auto; 
      background: white;
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 20px;
    }
    .main-content { flex: 1; }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 15px;
    }
    .logo-left { width: 150px; text-align: left; }
    .logo-left img { width: 145px; height: auto; }
    .ville-title { text-align: center; flex: 1; }
    .ville-title h1 { font-size: 20px; font-weight: bold; margin: 0; letter-spacing: 2px; }
    .ville-title .commune { font-size: 14px; font-weight: bold; margin: 3px 0 0 0; }
    .ville-title .service { font-size: 12px; margin: 2px 0 0 0; }
    .logo-right { width: 130px; text-align: right; }
    .logo-right img { width: 120px; height: auto; }
    .main-title { text-align: center; margin: 20px 0 20px 0; }
    .main-title .note-title { font-size: 14px; font-weight: bold; text-decoration: underline; letter-spacing: 0.5px; }
    .corps { margin: 15px 0; line-height: 1.6; font-size: 13px; }
    .corps p { margin: 6px 0; }
    .tax-table { width: 100%; border-collapse: collapse; margin: 15px 0; font-size: 12px; }
    .tax-table th { border: 1px solid #000; padding: 8px; background-color: #f5f5f5; font-weight: bold; text-align: center; }
    .tax-table td { border: 1px solid #000; padding: 6px 8px; }
    .total-row { font-weight: bold; background-color: #f9f9f9; }
    .note-importante { margin: 15px 0; font-size: 11px; font-style: italic; line-height: 1.4; }
    .note-importante p { margin: 8px 0; }
    .signature { margin-top: 30px; text-align: center; }
    .signature p { margin: 3px 0; }
    .footer { margin-top: auto; font-size: 10px; text-align: center; border-top: 1px solid #ccc; padding-top: 8px; width: 100%; }
    .footer-logos { display: flex; justify-content: center; gap: 15px; margin-bottom: 5px; }
    .bold { font-weight: bold; }
    .text-center { text-align: center; }
    .text-right { text-align: right; }
    .mt-2 { margin-top: 8px; }
    .visa { text-align: center; margin-top: 5px; }
  </style>
</head>
<body>
  <div class="document">
    <div class="main-content">
      <div class="header">
        <div class="logo-left">
          <img src="${mairieLogo}" alt="Logo" />
        </div>
      </div><br>
      <div class="main-title">
        <div class="note-title">NOTE DE TAXATION N° ${getTaxationNumberValue()}</div>
      </div>
      <div class="corps">
        <p>Madame, Mademoiselle, Monsieur, Responsable des ETS(STE) <strong>${getDenomination()}</strong></p>
        <p>Sis(e) au <strong>${numeroAdresse || "..."}</strong>, quartier <strong>${quartierNom || "..."}</strong>, Commune de <strong>${communeNom || "Lemba"}</strong>;</p>
        ${hasTaxesDue ? `
        <p class="mt-2">Sauf erreur ou omission de notre part, vous êtes redevable envers le Trésor municipal d'un montant total de <strong>${montantTotal.toLocaleString('fr-FR')} Francs congolais</strong>, éclaté de la manière suivante :</p>
        ` : `
        <p class="mt-2">Nous vous informons que votre situation fiscale est à jour. Vous n'êtes actuellement redevable d'aucun montant auprès du Trésor municipal.</p>
        `}
      </div>
      ${hasTaxesDue ? `
      <table class="tax-table">
        <thead>
          <tr>
            <th style="width: 50px;">N°</th>
            <th>Libellé des Actes</th>
            <th style="width: 150px;">Montant dû</th>
          </tr>
        </thead>
        <tbody>
          ${generateTaxRows()}
          <tr class="total-row">
            <td colspan="2" style="padding: 8px; border: 1px solid #000; text-align: right; font-weight: bold;">MONTANT TOTAL DÛ EN FRANCS CONGOLAIS<\/td>
            <td style="padding: 8px; border: 1px solid #000; text-align: right; font-weight: bold;">${montantTotal.toLocaleString('fr-FR')}<\/td>
          <\/tr>
        </tbody>
      <\/table>
      <div class="note-importante">
        <p>Ce montant est à verser intégralement entre les mains du percepteur, endéans 8 jours francs, <strong>faute de quoi il vous sera appliqué une majoration de l'ordre de 20 % du montant à payer</strong>, conformément à la législation en la matière pour non-respect du délai qui vous a été imparti lors du dépôt de la présente note de taxation.</p>
        <p class="mt-2"><strong>N.B : Ce montant de la Taxe Professionnelle Annuelle (TPA) fixé conformément au canevas budgétaire de la Commune de ${communeNom || "Lemba"}, n'est pas négociable.</strong></p>
      </div>
      ` : ''}
      <div class="signature">
        <p>FAIT A ${villeNom.toUpperCase() || "KINSHASA"}, LE ${currentDay} / ${currentMonth} / ${currentYear}</p>
        <p class="mt-2 bold">LE CHEF DE SERVICE D'ASSIETTE</p>
      </div>
      <div class="visa"></div>
      <p>Visa BGM.</p>
    </div>
    <div class="footer">
      <p>VILLE DE KINSHASA - Commune de ${communeNom || "Lemba"} - Service de Comptabilité</p>
    </div>
  </div>
</body>
</html>`;

    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);
    
    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(htmlContent);
    iframeDoc.close();
    
    iframe.contentWindow.onload = () => {
      iframe.contentWindow.print();
      setTimeout(() => {
        if (document.body.contains(iframe)) document.body.removeChild(iframe);
        setIsPrinting(false);
      }, 1000);
    };
  };

  const fetchActivityTaxes = async (activityId) => {
    if (!activityId) {
      setSelectedActivityTaxes([]);
      return;
    }
    try {
      setLoadingActivityTaxes(true);
      const response = await axios.get(`${API_BASE_URL}/taxes-activity/${activityId}`, { headers: getHeaders() });
      if (response.data && Array.isArray(response.data)) {
        setSelectedActivityTaxes(response.data);
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        setSelectedActivityTaxes(response.data.data);
      } else {
        setSelectedActivityTaxes([]);
      }
    } catch (error) {
      console.error("Erreur chargement taxes:", error);
      setSelectedActivityTaxes([]);
    } finally {
      setLoadingActivityTaxes(false);
    }
  };

  // ✅ Fonction pour charger les marchés
  const fetchMarches = async () => {
    try {
      setLoadingMarches(true);
      const response = await axios.get(MARCHES_ENDPOINT, { 
        headers: getHeaders(),
        params: {
          per_page: 100
        }
      });
      
      let marchesData = [];
      if (response.data && response.data.code === 200) {
        marchesData = response.data.data || [];
      } else if (response.data && Array.isArray(response.data)) {
        marchesData = response.data;
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        marchesData = response.data.data;
      }
      
      setMarches(marchesData);
    } catch (error) {
      console.error("Erreur chargement marchés:", error);
      setMarches([]);
    } finally {
      setLoadingMarches(false);
    }
  };

  const formatCurrency = (amount) => {
    const defaultCurrency = sessionStorage.getItem("default_currency") || 'XAF';
    const numAmount = parseFloat(amount) || 0;
    return numAmount.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' ' + defaultCurrency;
  };

  const fetchAllLocalites = async () => {
    try {
      const response = await axios.get(LOCALITES_ENDPOINT, { headers: getHeaders() });
      let allLocalites = [];
      if (response.data && Array.isArray(response.data)) allLocalites = response.data;
      else if (response.data?.data && Array.isArray(response.data.data)) allLocalites = response.data.data;
      setAllLocalitesData(allLocalites);
      return allLocalites;
    } catch (error) {
      console.error("Erreur chargement localités:", error);
      return [];
    }
  };

  const fetchQuartiers = async () => {
    const def_type_localite = Number(sessionStorage.getItem("def_type_localite") || 1002);
    try {
      setLoadingQuartiers(true);
      const allLocalites = await fetchAllLocalites();
      const quartiersList = allLocalites.filter(l => l.type_code === def_type_localite);
      const sortedQuartiers = [...quartiersList].sort((a, b) => (a.nom || '').localeCompare(b.nom || ''));
      setQuartiers(sortedQuartiers);
    } catch (error) {
      console.error("Erreur chargement quartiers:", error);
      showAlert("Erreur de chargement des quartiers", "danger");
      setQuartiers([]);
    } finally {
      setLoadingQuartiers(false);
    }
  };

  useEffect(() => {
    if (formData.activite_contribuable) {
      fetchActivityTaxes(formData.activite_contribuable);
    } else {
      setSelectedActivityTaxes([]);
    }
  }, [formData.activite_contribuable]);

  useEffect(() => {
    const fieldsWeight = {
      denomination: { weight: 25, required: true },
      telephone: { weight: 25, required: true },
      nom: { weight: 5, required: false },
      prenom: { weight: 5, required: false },
      forme_juridique: { weight: 5, required: false },
      email: { weight: 5, required: false },
      adresse: { weight: 5, required: false },
      quartier_id: { weight: 8, required: false },
      id_marche: { weight: 7, required: false },
      id_nat: { weight: 5, required: false },
      rccm: { weight: 5, required: false },
      nif: { weight: 5, required: false }
    };
    
    let totalProgress = 0;
    Object.entries(fieldsWeight).forEach(([field, config]) => {
      const value = formData[field];
      let isFilled = false;
      if (field === 'forme_juridique') isFilled = value && value !== "" && value !== 0;
      else isFilled = value && typeof value === 'string' && value.trim().length > 0;
      if (isFilled) totalProgress += config.weight;
    });
    setFormProgress(Math.min(100, totalProgress));
  }, [formData]);

  const getAuthToken = () => sessionStorage.getItem("authToken");
  const getHeaders = () => {
    const token = getAuthToken();
    const headers = { "Content-Type": "application/json", "Accept": "application/json" };
    if (token) headers["Authorization"] = `Bearer ${token}`;
    return headers;
  };

  const fetchParentCategories = async () => {
    try {
      setLoadingParentCategories(true);
      const response = await axios.get(USAGER_CATEGORIES_ENDPOINT, { headers: getHeaders() });
      if (response.data && Array.isArray(response.data)) setParentCategories(response.data);
    } catch (error) { console.error("Erreur:", error); } finally { setLoadingParentCategories(false); }
  };

  const fetchCategories = async () => {
    try {
      setLoadingCategories(true);
      const response = await axios.get(`${API_BASE_URL}/activites?has_tax=yes`, { headers: getHeaders() });
      if (response.data.data && Array.isArray(response.data.data)) setCategories(response.data.data);
    } catch (error) { console.error("Erreur:", error); } finally { setLoadingCategories(false); }
  };

  const fetchFormesJuridiques = async () => {
    try {
      setLoadingFormes(true);
      const response = await axios.get(FORMES_ENDPOINT, { headers: getHeaders() });
      if (response.data && Array.isArray(response.data)) setFormesJuridiques(response.data);
    } catch (error) { setFormesJuridiques([]); } finally { setLoadingFormes(false); }
  };

  useEffect(() => {
    fetchCategories();
    fetchParentCategories();
    fetchFormesJuridiques();
    fetchQuartiers();
    if (canSeeMarcheSelect) {
      fetchMarches();
    }
  }, [canSeeMarcheSelect]);

  // ✅ Pré-sélectionner le marché de l'utilisateur SEULEMENT s'il n'y en a pas déjà un de sélectionné

  const showAlert = (message, type = 'danger', duration = 5000) => {
    setAlertMessage({ show: true, message, type });
    if (duration > 0) setTimeout(() => setAlertMessage({ show: false, message: '', type: 'info' }), duration);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    
    if (contribuableType === 'informel' && (name === 'nom' || name === 'prenom')) {
      const newNom = name === 'nom' ? value : formData.nom;
      const newPrenom = name === 'prenom' ? value : formData.prenom;
      const fullName = `${newNom || ''} ${newPrenom || ''}`.trim();
      if (fullName) {
        setFormData(prev => ({
          ...prev,
          denomination: fullName
        }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // ✅ Validation selon le type
    if (contribuableType === 'formel') {
      if (!formData.denomination?.trim()) { 
        showAlert("La dénomination est obligatoire pour les contribuables formels", 'danger'); 
        return; 
      }
    } else {
      // Mode informel - la dénomination est automatiquement remplie avec nom + prénom
      const fullName = `${formData.nom || ''} ${formData.prenom || ''}`.trim();
      if (!fullName) {
        showAlert("Le nom et prénom sont obligatoires pour les contribuables informels", 'danger');
        return;
      }
      if (!formData.nom?.trim()) {
        showAlert("Le nom est obligatoire pour les contribuables informels", 'danger');
        return;
      }
      if (!formData.prenom?.trim()) {
        showAlert("Le prénom est obligatoire pour les contribuables informels", 'danger');
        return;
      }
    }
    
    if (!formData.telephone?.trim()) { 
      showAlert("Le téléphone est obligatoire", 'danger'); 
      return; 
    }

    setLoading(true);
    try {
      // ✅ Préparer les données selon le type
      let submitData = {
        nom_entite: contribuableType === 'formel' ? formData.denomination.trim() : `${formData.nom?.trim() || ''} ${formData.prenom?.trim() || ''}`.trim(),
        admin_full_name: formData.nom || "",
        first_name: formData.prenom || "",
        forme_juridique: formData.forme_juridique ? Number(formData.forme_juridique) : null,
        activite_contribuable: formData.activite_contribuable || "",
        telephone: formData.telephone.trim(),
        email: formData.email || "",
        admin_email: formData.email || "",
        adresse: formData.adresse || "",
        localite_id: formData.quartier_id || null,
        code_postal: formData.code_postal || "",
        id_nat: formData.id_nat?.trim() || null,
        rccm: formData.rccm?.trim() || null,
        nif: formData.nif?.trim() || null,
        id_marche: formData.id_marche || null, // 🔥 null si vide
        is_active: true,
        role_id: 1012,
        type_contribuable: contribuableType
      };   

      // ✅ Pour les informels, on s'assure que la dénomination est bien nom + prénom
      if (contribuableType === 'informel') {
        const fullName = `${formData.nom?.trim() || ''} ${formData.prenom?.trim() || ''}`.trim();
        submitData.nom_entite = fullName;
        submitData.denomination = fullName;
      }

      console.log("Données soumises:", submitData);
      
      const response = await axios.post(TAXPAYERS_ENDPOINT, submitData, { headers: getHeaders() });
      setApiResponse(response.data);
      setShowResponseModal(true);
      
      if (response.data.entite) {
        const selectedActivity = categories.find(cat => cat.id_export === formData.activite_contribuable);
        const locationInfo = selectedQuartier ? extractLocationInfo(selectedQuartier.value, allLocalitesData) : null;
        
        setTimeout(() => {
          generateFicheRecensement(response.data.entite, selectedActivity, selectedActivityTaxes, locationInfo);
        }, 2000);
      }
      
    } catch (error) {
      console.error('Erreur:', error);
      setApiResponse(error.response?.data || { error: error.message });
      setShowResponseModal(true);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Si l'utilisateur n'est pas autorisé à enregistrer
  if (!canRegister) {
    return (
      <React.Fragment>
        <Header />
        <div className="main main-app p-3 p-lg-4">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div>
                <ol className="breadcrumb fs-sm mb-1">
                  <li className="breadcrumb-item"><Link to="">Tableau de bord</Link></li>
                  <li className="breadcrumb-item"><Link to="/agent/contribuables/liste">Contribuables</Link></li>
                  <li className="breadcrumb-item active">Nouveau contribuable</li>
                </ol>
                <h1 className="main-title mb-0 fs-2 fw-bold">Nouveau Contribuable</h1>
                <p className="text-muted mt-1 mb-0">Ajoutez un nouveau contribuable au registre</p>
              </div>
            </div>

            <Card className="border-0 shadow-sm">
              <Card.Body className="text-center py-5">
                <div className="mb-4">
                  <div className="bg-warning bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center mx-auto" style={{ width: 80, height: 80 }}>
                    <Lock size={40} className="text-warning" />
                  </div>
                </div>
                <h4 className="fw-bold text-warning">Accès non autorisé</h4>
                <p className="text-muted mb-4 max-width-500 mx-auto">
                  Vous n'avez pas les droits nécessaires pour enregistrer des contribuables.
                  <br />
                  <small className="d-block mt-2">
                    Rôle actuel : {userRoleId || 'Non défini'} - ID Marché : {userMarcheId || 'Aucun'}
                  </small>
                </p>
                <Button variant="primary" onClick={() => navigate(-1)}>
                  Retour
                </Button>
              </Card.Body>
            </Card>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <ol className="breadcrumb fs-sm mb-1">
                <li className="breadcrumb-item"><Link to="">Tableau de bord</Link></li>
                <li className="breadcrumb-item"><Link to="/agent/contribuables/liste">Contribuables</Link></li>
                <li className="breadcrumb-item active">Nouveau contribuable</li>
              </ol>
              <h1 className="main-title mb-0 fs-2 fw-bold">Nouveau Contribuable</h1>
              <p className="text-muted mt-1 mb-0">Ajoutez un nouveau contribuable au registre</p>
              {/* ✅ Badge d'information */}
             
              {isAdminPrincipal && (
                <Badge bg="primary" className="mt-2 ms-2">
                  <PersonBadge className="me-1" size={14} />
                  Admin Principal
                </Badge>
              )}
              {!hasMarket && (
                <Badge bg="secondary" className="mt-2 ms-2">
                  <Person className="me-1" size={14} />
                  Hors marché - Tous types disponibles
                </Badge>
              )}
            </div>
          </div>

          <Card className="border-0 shadow-sm mb-4 bg-white">
            <Card.Body className="py-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <small className="text-muted">Progression du formulaire</small>
                <small className="fw-bold text-primary">{formProgress}%</small>
              </div>
              <ProgressBar now={formProgress} variant="primary" className="rounded-pill" style={{ height: '8px' }} />
            </Card.Body>
          </Card>

          <Row>
            <Col lg={12}>
              <Card className="shadow-sm border-0 mb-4">
                <Card.Header className="bg-primary text-white d-flex align-items-center py-3">
                  <Building className="me-2" size={20} />
                  <span className="fw-semibold fs-5">Informations du contribuable</span>
                </Card.Header>
                <Card.Body className="p-4 bg-white">
                  <Form onSubmit={handleSubmit}>
                    
                    {/* ✅ SECTION : TYPE DE CONTRIBUABLE - VISIBLE POUR TOUS */}
                    {canSeeRadios && (
                      <div className="mb-4">
                        <h6 className="text-primary mb-3 pb-2 border-bottom">
                          <People className="me-2" size={16} /> Type de contribuable
                        </h6>
                        <div className="d-flex gap-3">
                          <div 
                            className={`p-3 rounded-3 border cursor-pointer flex-grow-1 ${contribuableType === 'formel' ? 'bg-primary bg-opacity-10 border-primary' : 'bg-light border-secondary'}`}
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleContribuableTypeChange('formel')}
                          >
                            <div className="d-flex align-items-center">
                              <div className={`rounded-circle p-2 me-3 ${contribuableType === 'formel' ? 'bg-primary' : 'bg-secondary'}`}>
                                <PersonBadge size={20} className="text-white" />
                              </div>
                              <div>
                                <div className="fw-bold">Formel</div>
                                <small className="text-muted">Entreprise avec dénomination sociale</small>
                              </div>
                              {contribuableType === 'formel' && (
                                <div className="ms-auto">
                                  <CheckCircle size={24} className="text-primary" />
                                </div>
                              )}
                            </div>
                          </div>
                          <div 
                            className={`p-3 rounded-3 border cursor-pointer flex-grow-1 ${contribuableType === 'informel' ? 'bg-success bg-opacity-10 border-success' : 'bg-light border-secondary'}`}
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleContribuableTypeChange('informel')}
                          >
                            <div className="d-flex align-items-center">
                              <div className={`rounded-circle p-2 me-3 ${contribuableType === 'informel' ? 'bg-success' : 'bg-secondary'}`}>
                                <Person size={20} className="text-white" />
                              </div>
                              <div>
                                <div className="fw-bold">Informel</div>
                                <small className="text-muted">Particulier sans dénomination sociale</small>
                              </div>
                              {contribuableType === 'informel' && (
                                <div className="ms-auto">
                                  <CheckCircle size={24} className="text-success" />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <Form.Text className="text-muted d-block mt-2">
                          <InfoCircle className="me-1" size={14} />
                          {contribuableType === 'formel' 
                            ? 'Les contribuables formels sont des entreprises avec une dénomination sociale.' 
                            : 'Les contribuables informels sont des particuliers identifiés par leur nom et prénom.'}
                        </Form.Text>
                      </div>
                    )}

                    {/* ✅ SECTION IDENTIFICATION - Masquée en mode informel */}
                    {!(contribuableType === 'informel' && canSeeRadios) ? (
                      <div className="mb-4">
                        <h6 className="text-primary mb-3 pb-2 border-bottom">
                          <Building className="me-2" size={16} /> Identification
                        </h6>
                        <Row>
                          <Col md={12}>
                            <Form.Group className="mb-3">
                              <Form.Label className="fw-medium">
                                Dénomination <span className="text-danger">*</span>
                              </Form.Label>
                              <Form.Control 
                                type="text" 
                                name="denomination" 
                                value={formData.denomination} 
                                onChange={handleChange} 
                                placeholder="Nom de l'entreprise" 
                                className="py-2 bg-light" 
                                required 
                              />
                              <Form.Text className="text-muted">Nom complet de l'entreprise</Form.Text>
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      // ✅ Message informatif en mode informel
                      <div className="mb-4">
                        <div className="p-3 bg-info bg-opacity-10 rounded-3 border border-info">
                          <div className="d-flex align-items-center">
                            <InfoCircle className="text-info me-2" size={24} />
                            <div>
                              <div className="fw-bold text-info">Mode informel</div>
                              <small className="text-muted">
                                La dénomination sera automatiquement composée à partir du <strong>Nom</strong> et du <strong>Prénom</strong> saisis ci-dessous.
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="mb-4">
                      <h6 className="text-primary mb-3 pb-2 border-bottom"><Person className="me-2" size={16} /> Identité</h6>
                      <Row>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              {canSeeRadios && contribuableType === 'informel' ? (
                                <>Nom <span className="text-danger">*</span></>
                              ) : (
                                'Nom'
                              )}
                            </Form.Label>
                            <Form.Control 
                              type="text" 
                              name="nom" 
                              value={formData.nom} 
                              onChange={handleChange} 
                              placeholder="Nom" 
                              className="py-2 bg-light" 
                              required={canSeeRadios && contribuableType === 'informel'}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              {canSeeRadios && contribuableType === 'informel' ? (
                                <>Prénom <span className="text-danger">*</span></>
                              ) : (
                                'Prénom'
                              )}
                            </Form.Label>
                            <Form.Control 
                              type="text" 
                              name="prenom" 
                              value={formData.prenom} 
                              onChange={handleChange} 
                              placeholder="Prénom" 
                              className="py-2 bg-light" 
                              required={canSeeRadios && contribuableType === 'informel'}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      {canSeeRadios && contribuableType === 'informel' && formData.nom && formData.prenom && (
                        <div className="mt-2 p-2 bg-success bg-opacity-10 rounded-3">
                          <small className="text-success d-flex align-items-center">
                            <CheckCircle className="me-1" size={14} />
                            Dénomination générée : <strong className="ms-1">{`${formData.nom} ${formData.prenom}`}</strong>
                          </small>
                        </div>
                      )}
                    </div>

                    <div className="mb-4">
                      <h6 className="text-primary mb-3 pb-2 border-bottom"><Receipt className="me-2" size={16} /> Documents légaux</h6>
                      <Row>
                        <Col md={4}>
                          <Form.Group>
                            <Form.Label><CreditCard className="me-1" size={14} /> ID NAT</Form.Label>
                            <Form.Control 
                              type="text" 
                              name="id_nat" 
                              value={formData.id_nat} 
                              onChange={handleChange} 
                              placeholder="Ex: NAT123456789" 
                              className="py-2 bg-light" 
                            />
                            <Form.Text className="text-muted">Identifiant National (optionnel)</Form.Text>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group>
                            <Form.Label><FileText className="me-1" size={14} /> RCCM</Form.Label>
                            <Form.Control 
                              type="text" 
                              name="rccm" 
                              value={formData.rccm} 
                              onChange={handleChange} 
                              placeholder="Ex: RC2024/001" 
                              className="py-2 bg-light" 
                            />
                            <Form.Text className="text-muted">Registre de Commerce (optionnel)</Form.Text>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group>
                            <Form.Label><Key className="me-1" size={14} /> NIF</Form.Label>
                            <Form.Control 
                              type="text" 
                              name="nif" 
                              value={formData.nif} 
                              onChange={handleChange} 
                              placeholder="Ex: 1234567890" 
                              className="py-2 bg-light" 
                            />
                            <Form.Text className="text-muted">Numéro d'Identification Fiscale (optionnel)</Form.Text>
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>

                    <div className="mb-4">
                      <h6 className="text-primary mb-3 pb-2 border-bottom"><Briefcase className="me-2" size={16} /> Activité</h6>
                      <Row>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Forme juridique</Form.Label>
                            <Select 
                              options={formesJuridiques.map(f => ({ value: f.forme_id, label: f.libelle || f.code }))}
                              value={formesJuridiques.find(f => f.forme_id === formData.forme_juridique) ? { value: formData.forme_juridique, label: formesJuridiques.find(f => f.forme_id === formData.forme_juridique)?.libelle } : null}
                              onChange={(selected) => { handleChange({ target: { name: 'forme_juridique', value: selected ? selected.value : '' } }); }}
                              isLoading={loadingFormes}
                              placeholder="Sélectionner une forme juridique..."
                              className="react-select-container"
                              classNamePrefix="react-select"
                              styles={{ control: (base) => ({ ...base, padding: '2px 0', backgroundColor: '#f8f9fa' }) }}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Activité</Form.Label>
                            {loadingCategories ? (
                              <div className="border rounded p-2 bg-light text-center"><Spinner animation="border" size="sm" /><span className="ms-2">Chargement des activités...</span></div>
                            ) : (
                              <>
                                <Select 
                                  options={categoryOptions}
                                  value={categoryOptions.find(opt => opt.value === formData.activite_contribuable) || null}
                                  onChange={handleCategoryChange}
                                  isClearable
                                  isSearchable
                                  placeholder="Rechercher une activité..."
                                  noOptionsMessage={() => "Aucune activité trouvée"}
                                  className="react-select-container"
                                  classNamePrefix="react-select"
                                  styles={{ control: (base, state) => ({ ...base, padding: '2px 0', backgroundColor: '#f8f9fa', borderColor: state.isFocused ? '#0d6efd' : '#dee2e6' }), option: (base, { isFocused, isSelected }) => ({ ...base, backgroundColor: isSelected ? '#0d6efd' : isFocused ? '#e9ecef' : 'white', color: isSelected ? 'white' : '#212529', cursor: 'pointer', padding: '10px 12px' }), menu: (base) => ({ ...base, zIndex: 9999 }) }}
                                />
                                {formData.activite_contribuable && (
                                  <div className="mt-3">
                                    {loadingActivityTaxes ? (
                                      <div className="text-center py-2"><Spinner animation="border" size="sm" /><span className="ms-2 text-muted">Chargement des taxes...</span></div>
                                    ) : selectedActivityTaxes.length > 0 ? (
                                      <Card className="border-0 bg-light"><Card.Body className="py-2 px-3"><div className="d-flex align-items-center justify-content-between mb-2"><small className="text-muted fw-semibold"><Receipt className="me-1" size={14} /> Taxes associées ({selectedActivityTaxes.length})</small><Button variant="link" size="sm" className="p-0 text-decoration-none" onClick={() => setShowTaxesModal(true)}><Eye size={14} className="me-1" /> Voir détails</Button></div><div className="d-flex flex-wrap gap-2">{selectedActivityTaxes.slice(0, 3).map((tax, idx) => (<Badge key={idx} bg="info" className="px-2 py-1">{tax.taxe_name || tax.type || `Taxe ${idx + 1}`}</Badge>))}{selectedActivityTaxes.length > 3 && (<Badge bg="secondary" className="px-2 py-1">+{selectedActivityTaxes.length - 3} autres</Badge>)}</div></Card.Body></Card>
                                    ) : (<div className="text-muted small mt-2"><ExclamationCircle className="me-1" size={12} /> Aucune taxe associée à cette activité</div>)}
                                  </div>
                                )}
                              </>
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>

                    <div className="mb-4">
                      <h6 className="text-primary mb-3 pb-2 border-bottom"><Map className="me-2" size={16} /> Localisation</h6>
                      <Row>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label><GeoAlt className="me-1" size={14} /> Adresse</Form.Label>
                            <Form.Control 
                              type="text" 
                              name="adresse" 
                              value={formData.adresse} 
                              onChange={handleChange} 
                              placeholder="Adresse complète" 
                              className="py-2 bg-light" 
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label><GeoAlt className="me-1" size={14} /> Code postal</Form.Label>
                            <Form.Control 
                              type="text" 
                              name="code_postal" 
                              value={formData.code_postal} 
                              onChange={handleChange} 
                              placeholder="Code postal" 
                              className="py-2 bg-light" 
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12} className="mb-3 mt-3">
                          <Form.Group>
                            <Form.Label>Localité</Form.Label>
                            <Select 
                              options={quartierOptions} 
                              value={selectedQuartier} 
                              onChange={handleQuartierChange} 
                              isLoading={loadingQuartiers} 
                              placeholder={loadingQuartiers ? "Chargement des localités..." : "Sélectionner une localité..."} 
                              noOptionsMessage={() => "Aucune localité trouvée"} 
                              className="react-select-container" 
                              classNamePrefix="react-select" 
                              styles={{ control: (base) => ({ ...base, padding: '2px 0', backgroundColor: '#f8f9fa' }), option: (base) => ({ ...base, fontSize: '0.9rem', padding: '10px 12px' }) }} 
                            />
                            <Form.Text className="text-muted">Sélectionnez la localité - Le parent (quel que soit son type) est indiqué après le tiret</Form.Text>
                          </Form.Group>
                        </Col>
                      </Row>
                      {selectedQuartier && (
                        <div className="mt-2 p-3 bg-light rounded-3">
                          <small className="text-muted d-flex align-items-center"><GeoAlt className="me-2" size={14} />Quartier sélectionné :</small>
                          <div className="mt-2"><Badge bg="primary" className="fs-6 mb-2">{selectedQuartier.original.nom} (Quartier)</Badge>
                          {selectedQuartier.parent && (<div className="mt-2"><small className="text-muted">Parent direct :</small><div className="mt-1"><Badge bg="secondary">{selectedQuartier.parent.nom} ({getTypeName(selectedQuartier.parent.type_code)})</Badge></div></div>)}
                          {selectedQuartier.hierarchy && selectedQuartier.hierarchy.length > 0 && (<div className="mt-2"><small className="text-muted">Hiérarchie complète :</small><div className="mt-1">{selectedQuartier.hierarchy.map((item, index) => (<React.Fragment key={index}><Badge bg="info" className="me-1">{item.nom} ({item.type})</Badge>{index < selectedQuartier.hierarchy.length - 1 && <span className="mx-1 text-muted">→</span>}</React.Fragment>))}{selectedQuartier.hierarchy.length > 0 && (<span className="mx-1 text-muted">→</span>)}<Badge bg="success">{selectedQuartier.original.nom} (Quartier)</Badge></div></div>)}</div>
                        </div>
                      )}
                    </div>

                    {/* ✅ SECTION MARCHÉ - TOUJOURS ÉDITABLE */}
                   {canSeeMarcheSelect && (
  <div className="mb-4">
    <h6 className="text-primary mb-3 pb-2 border-bottom">
      <Shop className="me-2" size={16} /> Marché (optionnel)
    </h6>
    <p className="text-muted small mb-3">
      <InfoCircle className="me-1" size={14} />
      Vous pouvez assigner un marché à ce contribuable ou laisser vide.
    </p>
    <Row>
      <Col md={12}>
        <Form.Group>
          <Form.Label>Marché</Form.Label>
          
          {/* Bouton pour utiliser le marché par défaut */}
          {hasMarket && (
            <div className="mb-2">
              <Button
                variant="outline-primary"
                size="sm"
                className="rounded-pill"
                onClick={() => {
                  const userMarche = marches.find(m => m.id_marche === userMarcheId);
                  if (userMarche) {
                    setSelectedMarche({
                      value: userMarche.id_marche,
                      label: `${userMarche.id_marche} - ${userMarche.nom_marche}`,
                      original: userMarche
                    });
                    setFormData(prev => ({
                      ...prev,
                      id_marche: userMarche.id_marche
                    }));
                  }
                }}
              >
                <Shop className="me-1" size={14} />
                Utiliser mon marché : {marches.find(m => m.id_marche === userMarcheId)?.nom_marche || userMarcheId}
              </Button>
            </div>
          )}
          
          <Select
            options={marcheOptions}
            value={selectedMarche}
            onChange={handleMarcheChange}
            isLoading={loadingMarches}
            isClearable
            isSearchable
            placeholder={
              loadingMarches 
                ? "Chargement des marchés..." 
                : "Sélectionner un marché (ou laisser vide pour hors marché)..."
            }
            noOptionsMessage={() => "Aucun marché trouvé"}
            className="react-select-container"
            classNamePrefix="react-select"
            styles={{
              control: (base) => ({
                ...base,
                padding: '2px 0',
                backgroundColor: '#f8f9fa',
                borderColor: '#dee2e6'
              }),
              option: (base, { isFocused, isSelected }) => ({
                ...base,
                backgroundColor: isSelected ? '#0d6efd' : isFocused ? '#e9ecef' : 'white',
                color: isSelected ? 'white' : '#212529',
                cursor: 'pointer',
                padding: '10px 12px'
              }),
              menu: (base) => ({
                ...base,
                zIndex: 9999
              })
            }}
          />
          
          <Form.Text className="text-muted d-block mt-2">
            <Shop className="me-1" size={12} />
            {hasMarket 
              ? "Choisissez un marché ou laissez vide pour un contribuable hors marché" 
              : "Sélectionnez le marché auquel est rattaché le contribuable, ou laissez vide"}
          </Form.Text>
        </Form.Group>
      </Col>
    </Row>
    
    {/* Affichage du marché sélectionné */}
    {selectedMarche && (
      <div className="mt-2 p-3 bg-light rounded-3">
        <small className="text-muted d-flex align-items-center">
          <Shop className="me-2" size={14} />
          Marché sélectionné :
        </small>
        <div className="mt-1">
          <Badge bg="success" className="fs-6">
            <Shop className="me-1" size={14} />
            {selectedMarche.label}
          </Badge>
          {selectedMarche.original && (
            <div className="mt-2">
              <small className="text-muted">Détails du marché :</small>
              <div className="mt-1">
                <Badge bg="info" className="me-1">
                  Code: {selectedMarche.original.code_marche || selectedMarche.original.id_marche || 'N/A'}
                </Badge>
                {selectedMarche.original.etat && (
                  <Badge bg={selectedMarche.original.etat === 'Ouvert' ? 'success' : 'danger'}>
                    {selectedMarche.original.etat}
                  </Badge>
                )}
                {selectedMarche.original.superficie && (
                  <Badge bg="secondary" className="ms-1">
                    {selectedMarche.original.superficie} m²
                  </Badge>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    )}
    
    {/* Indication "Hors marché" quand vide */}
    {!selectedMarche && (
      <div className="mt-2">
        <Badge bg="secondary" className="px-3 py-2 rounded-pill">
          <InfoCircle className="me-1" size={12} />
          Aucun marché assigné (hors marché)
        </Badge>
      </div>
    )}
  </div>
)}

                    <div className="mb-4">
                      <h6 className="text-primary mb-3 pb-2 border-bottom"><Phone className="me-2" size={16} /> Contact</h6>
                      <Row>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-medium">Téléphone <span className="text-danger">*</span></Form.Label>
                            <Form.Control 
                              type="tel" 
                              name="telephone" 
                              value={formData.telephone} 
                              onChange={(e) => { const onlyNumbers = e.target.value.replace(/\D/g, ''); handleChange({ ...e, target: { ...e.target, name: 'telephone', value: onlyNumbers } }); }} 
                              placeholder="XXX XXX XXX" 
                              className="py-2 bg-light" 
                              required 
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Email</Form.Label>
                            <Form.Control 
                              type="email" 
                              name="email" 
                              value={formData.email} 
                              onChange={handleChange} 
                              placeholder="exemple@email.com" 
                              className="py-2 bg-light" 
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>

                    <hr className="my-4" />
                    <div className="d-flex gap-3 justify-content-end">
                      <Button 
                        type="submit" 
                        variant="success" 
                        disabled={
                          loading || 
                          !formData.telephone?.trim() || 
                          (contribuableType === 'formel' && !formData.denomination?.trim()) || 
                          (contribuableType === 'informel' && (!formData.nom?.trim() || !formData.prenom?.trim()))
                        } 
                        className="d-flex align-items-center px-4 py-2"
                      >
                        {loading ? <><Spinner animation="border" size="sm" className="me-2" />Enregistrement...</> : <><Save className="me-2" size={16} />Enregistrer le contribuable</>}
                      </Button>
                    </div>
                  </Form>

                  {alertMessage.show && (
                    <div className="mb-4 mt-3">
                      <Alert variant={alertMessage.type} dismissible onClose={() => setAlertMessage({ show: false, message: '', type: 'info' })} className="shadow-sm border-0">
                        <div className="d-flex align-items-center">
                          {alertMessage.type === 'success' ? <Check className="me-2 fs-5" /> : alertMessage.type === 'danger' ? <X className="me-2 fs-5" /> : <ExclamationCircle className="me-2 fs-5" />}
                          <span className="fw-medium">{alertMessage.message}</span>
                        </div>
                      </Alert>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

      <Modal show={showResponseModal} onHide={() => setShowResponseModal(false)} size="lg" centered backdrop="static">
  <Modal.Header closeButton className={apiResponse?.entite ? "bg-success text-white" : "bg-danger text-white"}>
    <Modal.Title>{apiResponse?.entite ? <><CheckCircle className="me-2" size={24} />Contribuable créé avec succès !</> : <><ExclamationCircle className="me-2" size={24} />Erreur lors de la création</>}</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
    {apiResponse?.entite ? (
      <div className="mb-4">
        <h5 className="text-primary mb-3"><Building className="me-2" size={18} />Informations de l'entité</h5>
        <div className="table-responsive"><table className="table table-bordered"><tbody>
          <tr className="table-light"><td className="fw-semibold">ID Contribuable</td><td><code>{apiResponse.entite.contribuable_id}</code></td></tr>
          <tr><td className="fw-semibold">Nom / Dénomination</td><td>{apiResponse.entite.nom_contribuable}</td></tr>
          <tr className="table-light"><td className="fw-semibold">Téléphone</td><td>{apiResponse.entite.telephone}</td></tr>
          <tr><td className="fw-semibold">Email</td><td>{apiResponse.entite.email}</td></tr>
          <tr className="table-light"><td className="fw-semibold">Activité</td><td>{apiResponse.entite.activite_contribuable}</td></tr>
          {apiResponse.entite.id_marche && (
            <tr><td className="fw-semibold">Marché</td><td><Badge bg="info">{apiResponse.entite.id_marche}</Badge></td></tr>
          )}
          {!apiResponse.entite.id_marche && (
            <tr><td className="fw-semibold">Marché</td><td><Badge bg="secondary">Hors marché</Badge></td></tr>
          )}
          {apiResponse.entite.type_contribuable && (
            <tr className="table-light"><td className="fw-semibold">Type</td>
              <td>
                <Badge bg={apiResponse.entite.type_contribuable === 'formel' ? 'primary' : 'success'}>
                  {apiResponse.entite.type_contribuable === 'formel' ? 'Formel' : 'Informel'}
                </Badge>
              </td>
            </tr>
          )}
        </tbody></table></div>
      </div>
    ) : (
      <Alert variant="danger"><ExclamationCircle className="me-2" />{apiResponse?.message || "Une erreur est survenue"}</Alert>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowResponseModal(false)}>Fermer</Button>
    {apiResponse?.entite && (
      <>
        <Button variant="info" onClick={() => {
          const selectedActivity = categories.find(cat => cat.id_export === formData.activite_contribuable);
          const locationInfo = selectedQuartier ? extractLocationInfo(selectedQuartier.value, allLocalitesData) : null;
          generateFicheRecensement(apiResponse.entite, selectedActivity, selectedActivityTaxes, locationInfo);
        }}>
          <Printer className="me-2" /> Imprimer la note de taxation
        </Button>
        <Button variant="success" onClick={() => { setShowResponseModal(false); window.location.reload(); }}>
          <PlusCircle className="me-2" /> Nouveau contribuable
        </Button>
      </>
    )}
  </Modal.Footer>
</Modal>

        <Modal show={showTaxesModal} onHide={() => setShowTaxesModal(false)} size="lg" centered>
          <Modal.Header closeButton className="bg-primary text-white">
            <Modal.Title><Receipt className="me-2" size={20} /> Taxes de l'activité</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <h6 className="mb-2">Activité : <Badge bg="primary" className="ms-2">{categoryOptions.find(opt => opt.value === formData.activite_contribuable)?.label || formData.activite_contribuable}</Badge></h6>
              <p className="text-muted small">Cette activité comporte {selectedActivityTaxes.length} taxe(s) associée(s)</p>
            </div>
            {loadingActivityTaxes ? (
              <div className="text-center py-4"><Spinner animation="border" variant="primary" /><p className="mt-2">Chargement des taxes...</p></div>
            ) : selectedActivityTaxes.length === 0 ? (
              <div className="text-center py-4"><Receipt size={48} className="text-muted opacity-25 mb-3" /><p className="text-muted">Aucune taxe associée à cette activité</p></div>
            ) : (
              <div className="table-responsive">
                <Table hover><thead className="table-light"><tr><th>Code</th><th>Intitulé</th><th>Montant</th><th>Fréquence</th></tr></thead><tbody>
                  {selectedActivityTaxes.map((tax, idx) => (<tr key={idx}><td><Badge bg="secondary">{tax.taxe_id || tax.id}</Badge></td><td><strong>{tax.taxe_name || tax.type || tax.titre}</strong>{tax.description && (<small className="d-block text-muted">{tax.description.substring(0, 60)}...</small>)}</td><td className="text-primary fw-bold">{formatCurrency(tax.default_amount || tax.montant || 0)}</td><td><Badge bg="info">{tax.default_frequency || 'Mensuelle'}</Badge></td></tr>))}
                </tbody></Table>
              </div>
            )}
            <div className="alert alert-info mt-3"><div className="d-flex align-items-center"><InfoCircle className="me-2" size={18} /><small>Ces taxes seront automatiquement appliquées lors de la création du contribuable. Les montants et fréquences sont définis par l'administration fiscale.</small></div></div>
          </Modal.Body>
          <Modal.Footer><Button variant="secondary" onClick={() => setShowTaxesModal(false)}>Fermer</Button></Modal.Footer>
        </Modal>

        <Footer />
      </div>

      <style>{`
        .form-control:focus, .form-select:focus { border-color: #0d6efd; box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25); }
        .progress-bar { transition: width 0.5s ease; }
        .react-select-container { width: 100%; }
        .react-select__control { background-color: #f8f9fa !important; border-color: #dee2e6 !important; }
        .react-select__control:hover { border-color: #0d6efd !important; }
        .react-select__control--is-focused { border-color: #0d6efd !important; box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25) !important; }
        .react-select__option { font-size: 0.9rem; }
        .react-select__option--is-focused { background-color: #e7f1ff !important; }
        .max-width-500 { max-width: 500px; }
        .cursor-pointer { cursor: pointer; }
        .cursor-pointer:hover { transform: translateY(-2px); transition: transform 0.2s; }
      `}</style>
    </React.Fragment>
  );
}